import {
  ButtonGroup,
  ButtonGroupCloseColorEnum,
  ButtonGroupCornerEnum,
  ButtonSizeEnum,
  FontColorEnum,
  FontSizeEnum,
  FontWeightEnum,
  IconSizeEnum,
  Tooltip,
  Typography,
} from '@acceso/design-system';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { CHANNEL_TYPE_STATES } from '@/constants';
import { useProgramBroadcastFilters } from '@/stores/program-broadcast-filters';

export function BroadcastScheduleProgramHeaderButtonFiltersChannelType() {
  const { channelType, setFilters } = useProgramBroadcastFilters();
  const { t } = useTranslation();

  const handleReviewStateChange = (state: string) => {
    if (channelType === state) {
      setFilters({ channelType: '' });
      return;
    }
    setFilters({ channelType: state });
  };

  return (
    <div className="flex items-center gap-2">
      {CHANNEL_TYPE_STATES.map(item => (
        <Tooltip help={t(item.label)} key={item.value} grow>
          <ButtonGroup
            size={ButtonSizeEnum.SM}
            onClick={() => handleReviewStateChange(item.value)}
            onClickClose={() => handleReviewStateChange(item.value)}
            closeColor={ButtonGroupCloseColorEnum.PRIMARY}
            isFilled={channelType === item.value}
            corner={ButtonGroupCornerEnum.FULL}
            className={clsx(
              'hover:!bg-neutral-20',
              channelType === item.value
                ? '!border-[2px] !border-accent-active-primary-20 bg-extra-new-95'
                : '!border'
            )}
            closeIcon={channelType.includes(item.value)}
          >
            <Typography
              fontSize={FontSizeEnum.Basic}
              weight={FontWeightEnum.Semibold}
              color={FontColorEnum.Dark10}
            >
              {<item.icon size={IconSizeEnum.SM} className={item.color} />}
            </Typography>
          </ButtonGroup>
        </Tooltip>
      ))}
    </div>
  );
}
